import { DentalOfficeShiftCard } from '@tempmee/react-blocks';
import { InviteProfessionalPopup } from '~/commonComponents/InviteProfessional/Popup';
import { useScheduleJobCard } from './useScheduleJobCard';

export const JobCard = ({ job, onCardClick }) => {
  const {
    cardData,
    handleInvite,
    menuItems,
    onReportIncident,
    incidentReported,
    canReportIncident,
    rebookPopup,
    isInvitePopupOpen,
    closeInvitePopup,
    cancelPopup,
  } = useScheduleJobCard(job);

  return (
    <>
      <DentalOfficeShiftCard
        {...cardData}
        onMessage={handleInvite}
        menuItems={menuItems}
        onReportIncident={onReportIncident}
        incidentReported={incidentReported}
        canReportIncident={canReportIncident}
        onCardClick={() => onCardClick(job)}
        data-cy="schedule-shift-card"
      />

      {rebookPopup}

      {isInvitePopupOpen && (
        <InviteProfessionalPopup
          isOpen={isInvitePopupOpen}
          isRefetchJob
          jobId={job?.id}
          profession={job?.profession}
          officeId={job?.offer_owner?.id}
          onClose={closeInvitePopup}
          trackingSource="Schedule List"
        />
      )}

      {cancelPopup}
    </>
  );
};
